import { Country, Locale } from './config';

export type Origin = 'web' | 'app';

export type AppQualifier = {
  environment?: string;
  shop: string;
  country: Country;
  locale: Locale;
  appId: number;
  apiHost: string;
  origin: Origin;
};

export const getAppQualifier = ({
  urlParams,
  element,
  injectedAppQualifier
}: {
  urlParams?: URLSearchParams;
  element?: HTMLElement;
  injectedAppQualifier?: AppQualifier;
}): AppQualifier => ({
  environment:
    urlParams?.get('environment') ?? element?.getAttribute('environment') ?? injectedAppQualifier?.environment,
  shop: urlParams?.get('shop') ?? element?.getAttribute('shop') ?? injectedAppQualifier?.shop ?? 'demo',
  country: (urlParams?.get('country') ??
    element?.getAttribute('country') ??
    injectedAppQualifier?.country ??
    'DE') as Country,
  locale: (urlParams?.get('locale') ??
    element?.getAttribute('locale') ??
    injectedAppQualifier?.locale ??
    'en_DE') as Locale,
  appId: urlParams?.get('appId')
    ? parseInt(urlParams.get('appId')!)
    : element?.getAttribute('app-id')
    ? parseInt(element.getAttribute('app-id')!)
    : element?.getAttribute('appId')
    ? parseInt(element.getAttribute('appId')!)
    : injectedAppQualifier?.appId ?? 139,
  apiHost:
    urlParams?.get('apiHost') ??
    element?.getAttribute('api-host') ??
    element?.getAttribute('apiHost') ??
    injectedAppQualifier?.apiHost ??
    '',
  origin: (urlParams?.get('origin') ??
    element?.getAttribute('origin') ??
    injectedAppQualifier?.origin ??
    'web') as Origin
});
